export default __webpack_public_path__ + "static/media/redirect.d8dfdf39.svg";